import {course_getCourses_Api} from 'apis'
import {createValue} from 'components/form/utils'
import React, {useMemo} from 'react'
import ContainerPicker, {renderDefaultActions,} from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper} from '../../../../components/selectors/BaseSelector'
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {renderIf} from "../../../Shared";
import _ from 'lodash'
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const CourseSelector = ({
                                   name,
                                   value,
                                   owner_id,
                                   owner_type,
                                   onChange = NullAsDefault,
                                   ...props
                               }) => {
    const defaultValue = value?.id ?? value

    const customConfigs = useMemo(() => ({
        apiInfo: course_getCourses_Api,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
    }), [owner_id, owner_type])

    return (
        <ContainerPicker
            name={name}
            allowClear={true}
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            placeholder="click to select"
            renderInnerWrapper={InnerWrapper}
            renderActions={renderDefaultActions(value)}
            renderOption={(o, i) => {

                const {title, time_open, time_close, last_enrollment_time} = o ?? {}

                return (
                    <div key={i} className="flex flex-col">
                        <span className="font-bold text-color-000 leading-6">{title}</span>
                        {renderIf(
                            _.some([time_open, time_close]),
                            <DoubleValueItem
                                labelFirst="time"
                                valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                labelSecond={time_open ? ' - ' : ''}
                                valueSecond={formatDate(time_close, 'DD/MM/YYYY')}
                                className="text-xs italic leading-tight"
                            />
                        )}

                    </div>
                )
            }}
            onOptionChange={(option) => {
                onChange(createValue(name, option ?? null))
            }}
            customConfigs={customConfigs}
            {...props}
        />
    )
}
